import { useEffect, useState } from 'react';
import { dropTargetForElements } from '@atlaskit/pragmatic-drag-and-drop/element/adapter';
import { attachClosestEdge, extractClosestEdge } from '@atlaskit/pragmatic-drag-and-drop-hitbox/closest-edge';

/**
 * Custom hook for making cards droppable
 */
export const useDroppableCard = ({ elementRef, cardId, columnId, onDrop }) => {
  const [dropState, setDropState] = useState({
    isOver: false,
    edge: null,
  });

  useEffect(() => {
    const element = elementRef.current;
    if (!element) return;

    const cleanup = dropTargetForElements({
      element,
      canDrop: ({ source }) => source.data.type === 'card' && source.data.cardId !== cardId,
      getData: ({ input }) => attachClosestEdge({ cardId, columnId }, { input, element, allowedEdges: ['top', 'bottom'] }),
      onDragEnter: ({ self }) => {
        setDropState({
          isOver: true,
          edge: extractClosestEdge(self.data),
        });
      },
      onDrag: ({ self }) => {
        setDropState({
          isOver: true,
          edge: extractClosestEdge(self.data),
        });
      },
      onDragLeave: () => {
        setDropState({ isOver: false, edge: null });
      },
      onDrop: ({ source, self }) => {
        setDropState({ isOver: false, edge: null });
        const edge = extractClosestEdge(self.data);

        onDrop({
          sourceCardId: source.data.cardId,
          sourceColumnId: source.data.columnId,
          sourceIndex: source.data.index,
          targetCardId: cardId,
          targetColumnId: columnId,
          edge,
          leadItem: source.data.leadItem, // Pass lead item from drag data
        });
      },
    });

    return cleanup;
  }, [elementRef, cardId, columnId, onDrop]);

  return dropState;
};
